import { SimpleSearchFilter } from 'module/api/filter/types';
import { PageType } from 'api/page-template/types';
import { HttpClient } from '../http-client';

export interface AiQueryRequest {
  aiQuery: string;
  groupedCriteria: SimpleSearchFilter;
  pageType: PageType;
}

export interface AiQueryResponse {
  generatedFilters: SimpleSearchFilter;
  message: string;
}

class AiQueryClient extends HttpClient {
  public async processAiQuery(
    params: AiQueryRequest,
  ): Promise<SimpleSearchFilter> {
    return this.post<SimpleSearchFilter, AiQueryRequest>(
      'pages/ai-query',
      params,
    );
  }
}

export const AiQueryAPI = new AiQueryClient();
